export var resource  = {
    types: {
        General: "General Insurance Coverage. Subject to the local regulations, Individual Contract, Collective Labor Agreement and Insurance Policies.",
        Flexible: "It is a remuneration system that optimizes your available net pay, using a portion of your salary to acquire products and services that the Company makes available to its employees. In this sense, the Flexible Compensation Plan is completely voluntary for the employee subject to the local regulations and Insurance Policies"
    }
}
